<template>
  <div>
    <div v-if="!empty">
      <section class="mt-4 mb-3">
        <section class="d-flex justify-content-between align-items-center">
          <div class="input-search col-md-5 p-0">
            <b-form-input
              v-model="search"
              placeholder="Digite para pesquisar"
              class="mb-2"
            />
            <b-button
              variant="light"
              class="px-2 d-flex align-items-center absolute icon-action"
            >
              <b-icon icon="search"></b-icon>
            </b-button>
          </div>
          <b-button class="btn-add" @click="handleOpenModalTemplate()">
            Adicionar
          </b-button>
        </section>
      </section>
      <cards-list grid="5" gap="8">
        <router-link
          v-for="(template, index) in templates"
          :key="index"
          :to="`/system/template-indicators/${template.id}/modules`"
        >
          <b-card class="p-3 card-insurance card-hoverable pointer" no-body>
            <div>
              <section>
                <div
                  class="d-flex justify-content-between align-items-start"
                  style="min-height: 50px"
                >
                  <strong class="d-block text-primary">
                    {{ template.name }}
                  </strong>
                </div>
                <hr />
                <small class="d-block" style="min-height: 70px">
                  {{ template.description }}
                </small>
              </section>
            </div>
          </b-card>
        </router-link>
      </cards-list>
    </div>
    <empty-list v-else text="Não há templates cadastrados">
      <b-button class="btn-add" @click="handleOpenModalTemplate()">
        Adicionar template de indicador
      </b-button>
    </empty-list>

    <b-modal
      id="add-indicator-template"
      centered
      hide-footer
      size="md"
      title="Adicionar"
      no-close-on-backdrop
    >
      <Form :id="selectedId" isAdd @submited="handleCloseModal" />
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Form from "./form.vue";

export default {
  components: {
    Form,
  },
  data() {
    return {
      empty: false,
      selectedTpl: {},
      selectedId: null,
      search: "",
      templates: [],
    };
  },

  methods: {
    ...mapActions(["get_all_templates", "show_delete"]),

    getAllTemplates() {
      this.get_all_templates().then(({ results, total }) => {
        this.empty = total === 0;
        this.templates = results;
      });
    },
    handleOpenModalTemplate() {
      this.selectedId = null;
      this.$bvModal.show("add-indicator-template");
    },
    handleCloseModal() {
      this.$bvModal.hide("add-indicator-template");
      this.getAllTemplates();
    },
  },
  mounted() {
    this.getAllTemplates();
  },
};
</script>
